import React from 'react';
import '../../css/ContentFooter.css';
import { completeSection } from '../../services/SectionService.ts';

const ContentFooter = ({
  sectionId,
  courseType,
  isComplete,
  chevronDirection,
  onChevronClick,
  onMenuClick,
  contextTitle,
  contextSection,
  onComplete
}) => {
const handleMarkComplete = async () => {
  try {
    console.log('Mark complete pressed', sectionId, courseType);
    await completeSection(courseType, sectionId);
    if (onComplete) {
      await onComplete();
    }
  } catch (error) {
    console.error("Failed to mark section as complete:", error);
  }
};

  return (
    <div className="footer-bar">
      <div className="footer-left">
        <button className="footer-context-btn" onClick={onMenuClick}>
          <i className="bi bi-menu-button-wide"></i>
          <div className="footer-context-texts">
            <span className="footer-context-title">{contextTitle}</span>
            <span className="footer-context-section">{contextSection}</span>
          </div>
        </button>
      </div>
      <div className="footer-center">
        <button
          className="mark-complete-btn"
          onClick={handleMarkComplete}
          disabled={!isComplete}
        >
          ✓ <span className="mark-complete-full">Mark complete</span>
          <span className="mark-complete-short">Complete</span>
        </button>
      </div>
      <div className="footer-right">
        <button
          className="footer-chevron-btn"
          onClick={onChevronClick}
          aria-label="Toggle sidebar"
        >
          <i className={`bi bi-chevron-${chevronDirection}`}></i>
        </button>
      </div>
    </div>
  );
};

export default ContentFooter;